import normalize from "json-api-normalizer";
import React, { useCallback } from "react";
import { useDispatch } from "react-redux";

import { receivePositionCorrespondence } from "../../../../actions/shared/jobcastUpdatesActions";
import ActionCableConsumer from "../../../shared/ActionCable/ActionCableConsumer";

function PositionCorrespondencesConsumer() {
  const dispatch = useDispatch();

  const handleReceived = useCallback(
    (data) => {
      const normalized = normalize(data);
      dispatch(receivePositionCorrespondence(normalized.positionCorrespondence));
    },
    [dispatch]
  );

  return (
    <ActionCableConsumer
      channel="PositionCorrespondencesChannel"
      onReceived={handleReceived}
    />
  );
}

export default PositionCorrespondencesConsumer;
